import { Box } from "@mui/material";
import { OnlineSession } from "./send-meeting-to-client/OnlineSession";
import { NeurofeedbackDataButton } from "./NeurofeedbackDataButton";
import { SessionNoteButton } from "./SessionNoteButton";
import { actions, onlineSessionActions } from "../sessionActions";
import { ActionsMenu } from "../../../components/actionsMenu/ActionsMenu";
import { RecordContext } from "../../../components/record/Record";
import { Session } from "../../../types/records.types";
import { EEG_SERVICES, NFB_SERVICE, FOLLOWUP_SERVICE, REPORTS_SERVICE, PSY_SERVICE } from "../../../utils/constants";

type SessionActionButtonsProps = {
	session: any;
	hasNote?: boolean;
};

export const SessionActionButtons = ({ session, hasNote }: SessionActionButtonsProps) => {
	const isTeamMeeting = !session?.service;
	const sessionCanBeOnline = !!session?.service?.can_be_online || isTeamMeeting;
	const recordContextValue = { item: session as Session } as any;

	const availableActions = sessionCanBeOnline ? [...(actions ?? []), ...(onlineSessionActions ?? [])] : actions;

	const isNFBorEEG = [...EEG_SERVICES, NFB_SERVICE].includes(session?.service?.id);
	const showCaseManagementNote = [FOLLOWUP_SERVICE, REPORTS_SERVICE].includes(session?.service?.id);
	const showPsychologyNote = session?.treatment?.id && session?.service?.id === PSY_SERVICE;

	return (
		<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2}}>
			{sessionCanBeOnline && <OnlineSession session={session} />}
			{isNFBorEEG && <NeurofeedbackDataButton calendarSession={session} />}
			{showCaseManagementNote && <SessionNoteButton session={session} hasNote={hasNote} category="client_owner" treatmentTab="notes" />}
			{showPsychologyNote && <SessionNoteButton session={session} hasNote={hasNote} category="psychology" treatmentTab="psychology" />}
			<RecordContext.Provider value={recordContextValue}>
				{availableActions ? <ActionsMenu actions={availableActions} disableElevation /> : null}
			</RecordContext.Provider>
		</Box>
	);
};
